export const API_URL = import.meta.env.VITE_API_URL as string;
export const API_V2_URL = import.meta.env.VITE_API_V2_URL as string;

export const KASPI_SHOP_URL = "https://kaspi.kz/shop";
export const KASPI_IMAGE_CDN_URL = "https://resources.cdn-kaspi.kz/img/m/p/";

export const ACCESS_STORAGE_KEY = "optims.auth.access";
